import './index.css';

function ProgressBar({value_percent}){
  return (
    <>
      <div className="wrapper">
        <div className="progress-bar">
          <div className="bar" style={{width : `${value_percent}%`}}>
            <span className="perc">{value_percent}%</span>      
          </div>
        </div>
      </div>
    </>
  );
}
export default ProgressBar;